import AsyncSelect from "react-select/async";
import type { AsyncProps } from "react-select/async";
import type { GroupBase, MultiValue, OptionsOrGroups } from "react-select";
import { useCallback, useRef } from "react";

import { myAxios } from "src/components/common/functions";

import { SelectOption } from "../../types";

export function AsyncFormSelect({
	isMulti = false, 
	placeholder = "", 
	required = false, 
    form_id, 
	inputId,
	name,
	fileName, 
	value,
	onChange, 
}: {
	isMulti?: boolean;
	placeholder?: string;
	required?: boolean;
	name?: string;
    form_id?: number;
	inputId?: string;
	fileName: string;
	value: MultiValue<SelectOption> | SelectOption | null;
	onChange: (next: SelectOption | MultiValue<SelectOption> | null) => void;
}) {
	const typingTimeoutRef = useRef<number | null>(null);
	const loadOptions: AsyncProps<SelectOption, true, GroupBase<SelectOption>>["loadOptions"] = useCallback(
		(inputValue: string, callback: (options: OptionsOrGroups<SelectOption, GroupBase<SelectOption>>) => void) => {
			if (typingTimeoutRef.current) {
				window.clearTimeout(typingTimeoutRef.current);
			}
			const q = inputValue.trim();
			if (!q) {
				callback([]);
				return;
			}
			typingTimeoutRef.current = window.setTimeout(async () => {
				const formData = new FormData();
				formData.append("q", q);
                if(form_id !== undefined) formData.append("form_id", String(form_id));
				const res = await myAxios({ fileName, formData });
				if (!res) {
					callback([]);
					return;
				}
				callback(res.data);
			}, 500);
		},
		[fileName, form_id]
	);
	return (
		<>
			<AsyncSelect
				inputId = {inputId}
				isMulti = {isMulti}
				required = {required}
				cacheOptions
				defaultOptions = {false}
				loadOptions = {loadOptions}
				isClearable
				placeholder = {placeholder}
				value = {value ?? null}
				onChange = {opts => 
					isMulti?
					onChange(opts as MultiValue<SelectOption> ?? null):
					onChange(opts as SelectOption ?? null)
				}
				styles = {{
					container: base => ({
						...base,
						minWidth: 260
					})
				}}
			/>
			{/* Hidden inputs for FormData (one per record) */}
			{isMulti? 
			name && value && (value as MultiValue<SelectOption>).map(v => (
				<input
					key = {v.value}
					type = "hidden"
					name = {name}
					value = {(v as SelectOption).value ?? ""}
				/>
			))
			:
			name && value && 
				<input
					type = "hidden"
					name = {name}
					value = {(value as SelectOption).value ?? ""}
				/>
			}
		</>
	);
}
